// extracted by css-extract-rspack-plugin
export default {"defaultToggle":"bvSzTdQ1GSwvhXZp","defaultToggleLabel":"q7NIlDzZbkUevT5n"};